import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams, AgEvent, GridApi, IRowNode } from 'ag-grid-community';

import styles from './TogglesCellRenderer.module.less';

export interface ToggleClickEvent extends AgEvent {
	data: any,
	field: string
}

export interface IToggleCellRendererParams {
	toggleClick: (event: ToggleClickEvent) => void;
}

interface IToggleCellRendererMergedParams extends ICellRendererParams, IToggleCellRendererParams { }


@Component({
	selector: 'toggles-cell-renderer',
	template: `
	<div [ngClass]="styles.toggleContainer">
		<vb-toggle-button
			[ariaLabel]="data[field]"
			[(ngModel)]="data[field]"
			(ngModelChange)="onToggle()">
		</vb-toggle-button>
	</div>
	`,
	standalone: false
})
export class TogglesCellRendererComponent implements ICellRendererAngularComp {
	public readonly styles = styles;

	public data: any;
	public field: string;
	public toggleClick: (event: ToggleClickEvent) => void;

	private gridApi: GridApi;
	private rowNode: IRowNode;

	public refresh(params: IToggleCellRendererMergedParams): boolean {
		this.updateCell(params);
		return true;
	}

	public agInit(params: IToggleCellRendererMergedParams): void {
		this.updateCell(params);
	}

	public onToggle(): void {
		this.toggleClick({
			data: this.rowNode.data,
			field: this.field
		} as ToggleClickEvent);
	}

	private updateCell(params: IToggleCellRendererMergedParams) {
		this.data = params.data;
		this.field = params.colDef.field;
		this.gridApi = params.api;
		this.rowNode = params.node;
		this.toggleClick = params.toggleClick;
	}
}
